import { render, staticRenderFns } from "./HistoryOrderKidsDialog.vue?vue&type=template&id=35be16eb&scoped=true"
import script from "./HistoryOrderKidsDialog.vue?vue&type=script&lang=js"
export * from "./HistoryOrderKidsDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryOrderKidsDialog.vue?vue&type=style&index=0&id=35be16eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be16eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35be16eb')) {
      api.createRecord('35be16eb', component.options)
    } else {
      api.reload('35be16eb', component.options)
    }
    module.hot.accept("./HistoryOrderKidsDialog.vue?vue&type=template&id=35be16eb&scoped=true", function () {
      api.rerender('35be16eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/ExcelTableDialog/HistoryOrderKidsDialog.vue"
export default component.exports